import { render, staticRenderFns } from "./SocietyBrandsPopup.vue?vue&type=template&id=cf823596&scoped=true"
import script from "./SocietyBrandsPopup.vue?vue&type=script&lang=js"
export * from "./SocietyBrandsPopup.vue?vue&type=script&lang=js"
import style0 from "./SocietyBrandsPopup.vue?vue&type=style&index=0&id=cf823596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf823596",
  null
  
)

export default component.exports